import { AppUser } from "./appUser.model";
import { SearchResult } from "./searchResult.model";
import { Profile } from "./profile.model";
import { SuggestedPlayerInfo } from "./suggestedPlayerInfo.model";

export class ProfileUser {
    constructor(json?: any) {
        this.appUser = json && new AppUser(json.app_user) || null;
        this.profile = json && new Profile(json.profile) || null;
        this.player = json && new SuggestedPlayerInfo(json.player_info) || null;
    }

    appUser: AppUser;
    profile: Profile;
    player: SuggestedPlayerInfo;

    profileUserToSearchResult(): SearchResult {
        var searchResult: SearchResult = new SearchResult();
        searchResult.playerRNID = this.appUser.playerRNID;
        searchResult.firstName = this.appUser.firstName;
        searchResult.lastName = this.appUser.lastName;
        searchResult.email = this.appUser.email;
        searchResult.jersey = this.profile.jersey?.toString();
        searchResult.position = this.profile.positionName;
        searchResult.appUserID = this.appUser.id;
        searchResult.profileImage = this.appUser.profileImage;
        searchResult.profileDescription = this.profile.description;
        searchResult.isRecruit = this.appUser.isRecruit;
        searchResult.isConnected = this.appUser.connected;
        searchResult.conversationSID = this.appUser.conversationSID;
        searchResult.matchPercent = this.appUser.matchPercent;
        searchResult.curTeamName = this.appUser.teamName;
        searchResult.homeTown = this.player.homeTown;
        searchResult.height = this.player.height;
        searchResult.weight = this.player.weight;
        searchResult.shoots = this.player.shoots;
        searchResult.catches = this.player.catches;
        searchResult.isScout = this.appUser.isScout;
        searchResult.position = this.player.position;
        searchResult.positionShort = this.player.positionShort;

        return searchResult;
    }
}